import React from 'react';

/**
 * Per-route error boundary — catches render errors within a section.
 * Shows a compact retry UI without reloading the page.
 */
export class RouteErrorBoundary extends React.Component {
  constructor (props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError (error) {
    return { hasError: true, error };
  }

  componentDidCatch (error, info) {
    console.error(`[${this.props.section || 'Route'}] Error:`, error, info?.componentStack);
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null });
  };

  render () {
    if (this.state.hasError) {
      return (
        <div className="route-error-boundary">
          <h3>Ошибка{this.props.section ? ` в разделе "${this.props.section}"` : ''}</h3>
          <p className="route-error-boundary__message">
            {this.state.error?.message || 'Неизвестная ошибка'}
          </p>
          <div style={{ display: 'flex', gap: '0.75rem' }}>
            <button className="ghost-button" onClick={this.handleReset}>
              Попробовать снова
            </button>
            <button className="ghost-button" onClick={() => window.location.reload()}>
              Перезагрузить
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
